import * as React from "react";
import { DocumentTitle, PageHeader, Spinner } from "components/common";
import withParams from "routing/withParams";
import { Col, Row } from "components/bootstrap";
import ForwarderDocs from "forwarder/util/ForwarderDocs";
import LicenseCheck from "license/LicenseCheck";
import { LICENSE_SUBJECTS } from "license/constants";
import ForwarderInputProfile from "./forwarders/ForwarderInputProfile";
import { ForwardersActions } from "./stores/ForwardersStore";
import ForwarderDetailsComponent from "./forwarders/ForwarderDetailsComponent";
import SingleForwarderProvider from "./forwarders/SingleForwarderProvider";
import ForwardersContext from "./forwarders/ForwardersContext";
import withIsPermitted from "./util/withIsPermitted";
import ForwarderPageNavigation from "./ForwarderPageNavigation";
const requiredPermissions = ({ params }) => [
  `forwarders:read:${params.forwarderId}`,
  "inputprofiles:read",
  "forwarderinputs:read"
];
const ForwarderPage = ({ params }) => {
  const _handleInputProfileSwitch = (forwarder) => (nextInputProfileId) => {
    const updatedForwarder = {
      input_profile_id: nextInputProfileId,
      title: forwarder.title,
      description: forwarder.description
    };
    ForwardersActions.update(forwarder.id, updatedForwarder).then(() => {
      ForwardersActions.get(params.forwarderId);
    });
  };
  return /* @__PURE__ */ React.createElement(SingleForwarderProvider, { forwarderId: params.forwarderId }, /* @__PURE__ */ React.createElement(ForwardersContext.Consumer, null, ({ forwarders }) => {
    const forwarder = forwarders[0];
    if (!forwarder) {
      return /* @__PURE__ */ React.createElement(Spinner, null);
    }
    return /* @__PURE__ */ React.createElement(DocumentTitle, { title: `Forwarder: ${forwarder.title}` }, /* @__PURE__ */ React.createElement(ForwarderPageNavigation, null), /* @__PURE__ */ React.createElement(
      PageHeader,
      {
        title: `Forwarder: ${forwarder.title}`,
        documentationLink: {
          title: "Input profile documentation",
          path: ForwarderDocs.INPUT_PROFILE
        }
      },
      /* @__PURE__ */ React.createElement("span", null, "Overview of ", forwarder.title, " Forwarder, including the Input Profile it is using.")
    ), /* @__PURE__ */ React.createElement(
      LicenseCheck,
      {
        licenseSubject: LICENSE_SUBJECTS.forwarder,
        displayWarningContainer: true,
        featureName: "Forwarder",
        bsStyle: "danger"
      }
    ), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(ForwarderDetailsComponent, { forwarder, onUpdate: () => {
    } })), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(
      ForwarderInputProfile,
      {
        forwarder,
        inputProfileId: forwarder.input_profile_id,
        onInputProfileSwitch: _handleInputProfileSwitch(forwarder)
      }
    ))));
  }));
};
export default withParams(withIsPermitted(ForwarderPage, requiredPermissions));
